class HeaveHoSubscriptionBuilder extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-coffee-option]:not([disabled])')];
    this.sizeSelect = this.querySelector('[data-size-select]');
    this.grindSelect = this.querySelector('[data-grind-select]');
    this.planSelect = this.querySelector('[data-plan-select]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.planInput = this.querySelector('[data-selling-plan-id]');
    this.submitButton = this.querySelector('[data-builder-submit]');
    this.status = this.querySelector('[data-builder-status]');
    this.price = this.querySelector('[data-builder-price]');

    this.buttons.forEach((button) => button.addEventListener('click', () => this.selectCoffee(button)));
    this.sizeSelect?.addEventListener('change', () => this.resolveVariant());
    this.grindSelect?.addEventListener('change', () => this.resolveVariant());
    this.planSelect?.addEventListener('change', () => this.resolvePlan());

    const initial = this.buttons.find((button) => button.classList.contains('is-selected')) || this.buttons[0];
    if (initial) this.selectCoffee(initial);
  }

  selectCoffee(button) {
    const configElement = document.getElementById(button.dataset.config);
    if (!configElement) return;
    try {
      this.config = JSON.parse(configElement.textContent);
    } catch (error) {
      this.disable('This coffee could not be loaded. Please refresh the page.');
      return;
    }

    this.buttons.forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });

    const normalizedNames = this.config.optionNames.map((name) => name.toLowerCase());
    this.sizeIndex = normalizedNames.findIndex((name) => name.includes('size'));
    this.grindIndex = normalizedNames.findIndex((name) => name.includes('grind') || name.includes('beans'));
    this.populateOption(this.sizeSelect, this.sizeIndex, 'Standard');
    this.populateOption(this.grindSelect, this.grindIndex, 'Whole bean');
    this.resolveVariant();
  }

  populateOption(select, optionIndex, fallbackLabel) {
    if (!select) return;
    const values = optionIndex < 0
      ? [fallbackLabel]
      : [...new Set(this.config.variants.filter((variant) => variant.available).map((variant) => variant.options[optionIndex]))];
    select.innerHTML = '';
    values.forEach((value) => select.add(new Option(value, value)));
    select.disabled = values.length < 2;
  }

  resolveVariant() {
    if (!this.config) return;
    const variant = this.config.variants.find((item) => {
      if (!item.available) return false;
      const sizeMatches = this.sizeIndex < 0 || item.options[this.sizeIndex] === this.sizeSelect.value;
      const grindMatches = this.grindIndex < 0 || item.options[this.grindIndex] === this.grindSelect.value;
      return sizeMatches && grindMatches;
    });

    if (!variant) {
      this.disable('That size and grind combination is currently unavailable.');
      return;
    }

    this.variant = variant;
    this.variantInput.value = variant.id;
    this.planSelect.innerHTML = '';
    variant.allocations.forEach((allocation) => this.planSelect.add(new Option(allocation.name, allocation.id)));
    this.planSelect.disabled = variant.allocations.length < 2;

    if (!variant.allocations.length) {
      this.planInput.value = '';
      this.disable('Subscription plans are not connected to this product yet. Choose a subscription-enabled product or shop it as a one-time purchase below.');
      return;
    }

    this.submitButton.disabled = false;
    this.status.textContent = 'Flexible plan. Manage, skip, or cancel through your customer account.';
    this.resolvePlan();
  }

  resolvePlan() {
    if (!this.variant?.allocations?.length) return;
    const allocation = this.variant.allocations.find((item) => String(item.id) === this.planSelect.value) || this.variant.allocations[0];
    this.planInput.value = allocation.id;
    this.price.textContent = `${allocation.price} per delivery`;
  }

  disable(message) {
    if (this.submitButton) this.submitButton.disabled = true;
    if (this.variantInput) this.variantInput.value = '';
    if (this.planInput) this.planInput.value = '';
    if (this.price) this.price.textContent = '';
    if (this.status) this.status.textContent = message;
  }
}

if (!customElements.get('subscription-builder')) customElements.define('subscription-builder', HeaveHoSubscriptionBuilder);

function attachAttribution(root = document) {
  const params = new URLSearchParams(window.location.search);
  const names = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'fbclid'];
  const values = names.reduce((result, name) => {
    const value = params.get(name);
    if (value) result[name] = value;
    return result;
  }, {});
  const summary = Object.entries(values).map(([key, value]) => `${key}: ${value}`).join(' | ');
  root.querySelectorAll('[data-attribution-summary]').forEach((input) => { input.value = summary; });
  root.querySelectorAll('[data-email-capture] form').forEach((form) => {
    Object.entries(values).forEach(([name, value]) => {
      const input = form.querySelector(`[name="${name}"]`);
      if (input) input.value = value;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => attachAttribution());
document.addEventListener('shopify:section:load', (event) => attachAttribution(event.target));
